<template>
    <div class="page-content">
        <UserHeadline title="YourProfile.title" />
        <div class="page-content__profile">
            <div class="page-content__user-info">
                <UserInfo :user="userInfo" :currentOrder="currentOrder"/>
                <UserInfoForm :user="userInfo" v-on:updateUserInfo="updateUserInfoAndShowToast" :sortedJobTitles="sortedJobTitles" ref="userInfoForm"/>
            </div>
            <ChangePassword :has-password="userInfo.passwordIsSet" v-if="userInfo.passwordIsSet"/>
            <PackageInfo :packages="orderedPackages" />
        </div>
    </div>
</template>

<script>
    import accessHelper from 'helpers/accessHelper'
    import UserInfo from 'components/user/profile/UserInfo'
    import UserHeadline from 'components/user/UserHeadline'
    import UserInfoForm from 'components/user/profile/UserInfoForm'
    import PackageInfo from 'components/user/profile/PackageInfo.vue'
    import ChangePassword from 'components/user/profile/ChangePassword'
    import sortAlphabeticallyAscByJobTitle from 'components/shared/mixins/sorting/sortAlphabeticallyAscByJobTitle'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            UserInfoForm,
            UserInfo,
            UserHeadline,
            ChangePassword,
            PackageInfo
        },
        mixins: [ sortAlphabeticallyAscByJobTitle ],
        data () {
            return {
                jobTitles: [],
                sortedJobTitles: []
            }
        },
        computed: {
            ...mapGetters({
                user: 'User/getCurrentUser',
                currentOrder: 'User/getCurrentOrder',
                orderHistory: 'getOrderHistory',
                userInfo: 'User/getUserInfo',
                packageInfo: 'User/getPackageInfo'
            }),
            orderedPackages () {
                return this.packageInfo.filter(packageItem => packageItem.accessLevel >= accessHelper.ACCESS_LEVEL_FULL)
            }
        },
        async created () {
            const taskName = 'loadingUserProfile'
            try {
                await this.$store.dispatch('LoaderScreen/addTaskToLoader', { key: taskName, message: 'Loading UserProfile' })
                await this.refreshData()
            } catch (e) {}
            this.$store.dispatch('LoaderScreen/removeTaskFromLoader', taskName)
        },
        methods: {
            async updateUserInfoAndShowToast (newUserInfo) {
                await this.$store.dispatch('User/updateUserInfo', newUserInfo)
                this.$refs.userInfoForm.onUserUpdated()
            },
            async refreshData () {
                this.$store.dispatch('User/loadUserInfo')
                this.$store.dispatch('User/loadPackageInfo')
                this.jobTitles = await this.$store.dispatch('User/loadJobTitles')
                this.sortedJobTitles = this.sortAlphabeticallyAsc(this.jobTitles)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .page-content {
        &__profile {
            display: flex;
            flex-direction: column;
            gap: 40px;

            [class*="desktop"] & {
                flex-direction: row;
            }
        }

        &__user-info {
            display: flex;
            flex-direction: column;
            max-width: 382px;
            width: 100%;
        }
    }
</style>
